import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=1ef1676c&scoped=true&"
import script from "./VPopover.vue?vue&type=script&lang=js&"
export * from "./VPopover.vue?vue&type=script&lang=js&"
import style0 from "./VPopover.vue?vue&type=style&index=0&id=1ef1676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef1676c",
  null
  
)

export default component.exports